import { Outlet, useLocation } from "react-router-dom";
import React from "react";
import "./StoreLayout.css";

export default function StoreLayout() {
  const location = useLocation();

  React.useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const path = location?.pathname || "";

    const isStore = path.startsWith("/store");
    const isProductDetail = /^\/store\/product\/[^/]+/.test(path);

    const apply = (el, cls, on) => {
      if (!el) return;
      if (on) el.classList.add(cls);
      else el.classList.remove(cls);
    };

    apply(html, "is-store-route", isStore);
    apply(body, "is-store-route", isStore);
    apply(html, "is-store-product-detail", isProductDetail);
    apply(body, "is-store-product-detail", isProductDetail);

    // Provide a CSS variable for sticky offsets under the header.
    const setStickyTopVar = () => {
      if (!isProductDetail) {
        html.style.removeProperty("--store-sticky-top");
        return;
      }
      const headerEl = document.querySelector("header");
      const headerH = headerEl ? Math.round(headerEl.getBoundingClientRect().height || 0) : 0;
      const top = headerH > 0 ? headerH + 24 : 24;
      html.style.setProperty("--store-sticky-top", `${top}px`);
    };
    setStickyTopVar();
    window.addEventListener("resize", setStickyTopVar);

    return () => {
      apply(html, "is-store-route", false);
      apply(body, "is-store-route", false);
      apply(html, "is-store-product-detail", false);
      apply(body, "is-store-product-detail", false);
      html.style.removeProperty("--store-sticky-top");
      window.removeEventListener("resize", setStickyTopVar);
    };
  }, [location?.pathname]);

  return (
    <div className="store-layout-root">
      <Outlet />
    </div>
  );
}
